// ./utils/OrientationCertificate.jsx
import React from "react";
import jsPDF from 'jspdf';
import 'jspdf-autotable'; 

const OrientationCertificate = ({ form, user, onClose }) => {
  const workshopDate = form.lockedAt
    ? new Date(form.lockedAt).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
      })
    : "N/A";

  const generatePDF = () => {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4'
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // Background color
    doc.setFillColor(15, 23, 42); // Dark navy
    doc.rect(0, 0, pageWidth, pageHeight, 'F');

    // Elegant border
    doc.setDrawColor(212, 175, 83); // Gold
    doc.setLineWidth(3);
    doc.rect(10, 10, pageWidth - 20, pageHeight - 20);

    // Inner border
    doc.setDrawColor(255, 255, 255);
    doc.setLineWidth(1);
    doc.rect(15, 15, pageWidth - 30, pageHeight - 30);

    // Header - ThinkWhys Logo Area
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(28);
    doc.setTextColor(212, 175, 83);
    doc.text("THINKWHYS", pageWidth / 2, 35, { align: 'center' });

    doc.setFontSize(12);
    doc.setTextColor(200, 200, 200);
    doc.text("Next Gen Entrepreneur Program", pageWidth / 2, 45, { align: 'center' });

    // Certificate Title
    doc.setFontSize(32);
    doc.setTextColor(255, 255, 255);
    doc.text("CERTIFICATE OF COMPLETION", pageWidth / 2, 68, { align: 'center' });

    // Decorative line
    doc.setDrawColor(212, 175, 83);
    doc.setLineWidth(1.5);
    doc.line(pageWidth * 0.2, 75, pageWidth * 0.8, 75);

    // Recipient
    doc.setFontSize(18);
    doc.setTextColor(255, 255, 255);
    doc.text("This is to certify that", pageWidth / 2, 95, { align: 'center' });

    doc.setFontSize(26);
    doc.setFont('helvetica', 'bold');
    doc.text(form.name?.toUpperCase() || "PARTICIPANT NAME", pageWidth / 2, 115, { align: 'center' });

    // Details
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(14);
    doc.setTextColor(220, 220, 220);

    const detailsY = 135;
    doc.text(`Date of Workshop: ${workshopDate}`, pageWidth / 2, detailsY, { align: 'center' });
    // doc.text(`Age: ${form.age || 'N/A'} years`, pageWidth / 2, detailsY + 10, { align: 'center' });

    // Location details
    const locationText = [
      user?.city ? `${user.city}, ${user.state}` : '',
      user?.country ? user.country : ''
    ].filter(Boolean).join(' | ');

    if (locationText) {
      doc.text(locationText, pageWidth / 2, detailsY + 20, { align: 'center' });
    }

    // Certificate Number
    doc.setFontSize(11);
    doc.setTextColor(180, 180, 180);
    const certNumber = user?.think5whyscode || 'CERT-' + Date.now().toString().slice(-8);
    doc.text(`Certificate No: DIGIB/${certNumber}`, pageWidth / 2, detailsY + 35, { align: 'center' });

    // Achievement Text
    doc.setFontSize(15);
    doc.setTextColor(255, 255, 255);
    const achievementText = "has successfully completed the Orientation Workshop";
    doc.text(achievementText, pageWidth / 2, detailsY + 55, { align: 'center' });

    // Signature area
    const sigY = pageHeight - 55;

    doc.setDrawColor(212, 175, 83);
    doc.setLineWidth(1);
    doc.line(pageWidth * 0.25, sigY - 5, pageWidth * 0.45, sigY - 5);
    doc.line(pageWidth * 0.65, sigY - 5, pageWidth * 0.85, sigY - 5);

    doc.setFontSize(11);
    doc.setTextColor(212, 175, 83);
    doc.text("Program Director", pageWidth * 0.35, sigY + 5, { align: 'center' });
    doc.text("ThinkWhys Academy", pageWidth * 0.75, sigY + 5, { align: 'center' });

    // Footer
    doc.setFontSize(10);
    doc.setTextColor(160, 160, 160);
    doc.text("Empowering Future Entrepreneurs | thinkwhys.com", pageWidth / 2, pageHeight - 15, { align: 'center' });

    // Optional: Add a subtle watermark or seal
    doc.setFontSize(60);
    doc.setTextColor(212, 175, 83, 0.08);
    doc.text("CERTIFIED", pageWidth / 2, pageHeight / 2 + 20, { align: 'center', angle: 30 });

    // Save the PDF
    const fileName = `${(form.name || 'Participant').replace(/\s+/g, '_')}_Orientation_Certificate.pdf`;
    doc.save(fileName);
  };

  // Auto-generate when component mounts (or trigger manually)
  React.useEffect(() => {
    generatePDF();
    if (onClose) onClose();
  }, []);

  return null; // This component doesn't render anything visible
};

export default OrientationCertificate;